"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrowserLocale = void 0;
const react_1 = require("react");
function useBrowserLocale() {
    const getNavigatorLanguage = () => {
        var _a;
        if ((_a = navigator.languages) === null || _a === void 0 ? void 0 : _a.length) {
            return navigator.languages[0];
        }
        else if (navigator.userLanguage) {
            return navigator.userLanguage;
        }
        else if (navigator.language) {
            return navigator.language;
        }
        else if (navigator.browserLanguage) {
            return navigator.browserLanguage;
        }
        else {
            return 'en';
        }
    };
    const navigatorLanguage = react_1.useMemo(() => {
        return getNavigatorLanguage() || null;
    }, []);
    return navigatorLanguage || '';
}
exports.useBrowserLocale = useBrowserLocale;
exports.default = useBrowserLocale;
//# sourceMappingURL=useBrowserLocale.js.map